module.exports = __webpack_public_path__ + "img/header_logo_main.994cbf2f.png";